import { render } from "./AllActiesPagina.vue?vue&type=template&id=2efb16e2&scoped=true"
import script from "./AllActiesPagina.vue?vue&type=script&lang=js"
export * from "./AllActiesPagina.vue?vue&type=script&lang=js"

import "./AllActiesPagina.vue?vue&type=style&index=0&id=2efb16e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efb16e2"]])

export default __exports__